import { HelpCircle } from "lucide-react";
import PopupProps from "./PopupProps";
import { WithTranslationProps } from '../Translation/WithTranslationProps';
import withTranslation from 'Common/withTranslation';
import { useState } from "react";

const Popup: React.FC<WithTranslationProps & PopupProps> = ({
    text,
    icon: Icon,
    size,
    t
}) => {
    const [show, setShow] = useState<boolean>(false);

    return (
        <div className="flex justify-center items-center" onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
            {Icon ? <Icon className="text-custom-500" width={size ? size : 20} /> : <HelpCircle className="text-custom-500" width={size ? size : 20} />}
            {show && <div className="absolute bg-custom-500 p-2 rounded">
                <div className="inline-block">
                    <span className="text-white text-xs text-justify">{t(text)}</span>
                </div>
            </div>
            }
        </div>
    )
}

export default withTranslation(Popup);